export const DATE_FORMAT = 'DD MMMM YYYY - hh:mm a';
export const PLACEHOLDER_DATE_NONE = 'Messages.NoneA';

export const EDITABLE_FIELD_TYPES = {
    DATE: 'date',
    STRING: 'string',
    TEXT: 'text',
};

export const SPECIAL_EDITABLE_FIELDS = {
    VEHICLE_DELIVERY_DATE: 'vehicleDeliveryDate',
};
